/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { ButtonTypes } from '@app/app/shared/styleguide/components/buttons/default/button.component';
import { LucideIconInput } from '@lucide/angular';

export type V3ContentCardView = 'grid' | 'list';

export const V3_CONTENT_CARD_GRADIENTS = [
  'linear-gradient(135deg, #ede9fe, #c4b5fd)',
  'linear-gradient(135deg, #eff6ff, #bfdbfe)',
  'linear-gradient(135deg, #ecfdf5, #6ee7b7)',
  'linear-gradient(135deg, #f5f3ff, #ddd6fe)',
  'linear-gradient(135deg, #fef9c3, #fde68a)',
  'linear-gradient(135deg, #fff1f2, #fecdd3)',
];

export type V3ContentCardStatusTone = 'draft' | 'unpublished' | 'archived' | 'success' | 'warning' | 'neutral';

export interface V3ContentCardStatusBadge {
  label: string;
  tone: V3ContentCardStatusTone;
  icon?: LucideIconInput;
}

export interface V3ContentCardMetaEntry {
  icon?: LucideIconInput;
  text: string;
}

export interface V3ContentCardAction {
  label: string;
  type: ButtonTypes;
}

export interface V3ContentCardItem {
  uid: string;
  title: string;
  titleIsPlaceholder?: boolean;
  subtitle?: string;
  thumbnail?: string | null;
  gradient?: string | null;
  coverIcon?: LucideIconInput | null;
  typeLabel?: string;
  typeIcon?: LucideIconInput | null;
  progress?: number | null;
  gradeLabel?: string | null;
  gradePassing?: boolean;
  statusBadge?: V3ContentCardStatusBadge | null;
  meta?: V3ContentCardMetaEntry[];
  tags?: string[];
  accent?: 'teal';
}
